export class ObjectCreator {
  constructor() {}

  static shallowCopy(obj) {
    if (obj === undefined) {
      return undefined;
    }
    if (obj == null) {
      return null;
    }
    if (Array.isArray(obj)) {
      let arr = [];
      for (let i = 0; i < obj.length; i++) {
        arr.push(obj[i]);
      }
      return arr;
    }
    if (typeof obj === "object") {
      let objCopy = {};
      for (const key of Object.getOwnPropertyNames(obj)) {
        objCopy[key] = obj[key];
      }
      return objCopy;
    }
    return obj;
  }

  static deepCopy(obj) {
    if (obj === undefined) {
      return undefined;
    }
    if (obj == null) {
      return null;
    }
    if (typeof obj === "function") {
      return obj;
    }
    if (Array.isArray(obj)) {
      let arr = [];
      for (let i = 0; i < obj.length; i++) {
        arr.push(ObjectCreator.deepCopy(obj[i]));
      }
      return arr;
    }
    if (typeof obj === "object") {
      let copyObj = {};
      for (const key of Object.getOwnPropertyNames(obj)) {
        copyObj[key] = ObjectCreator.deepCopy(obj[key]);
      }
      return copyObj;
    }
    return obj;
  }

  static addFields(srcObj, destObj, ignoredFields) {
    for (const key of Object.getOwnPropertyNames(srcObj)) {
      if (!ignoredFields.includes(key)) {
        destObj[key] = ObjectCreator.deepCopy(srcObj[key]);
      }
    }
  }

  static merge(detailedSettings, baseSettings) {
    if (baseSettings === undefined) {
      return ObjectCreator.deepCopy(detailedSettings);
    }
    if (detailedSettings === undefined) {
      return ObjectCreator.deepCopy(baseSettings);
    }
    if (Array.isArray(detailedSettings)) {
      return ObjectCreator.deepCopy(detailedSettings);
    } else if (typeof detailedSettings === "object") {
      let result = ObjectCreator.deepCopy(detailedSettings);
      for (const key of Object.getOwnPropertyNames(baseSettings)) {
        if (!Object.prototype.hasOwnProperty.call(result, key)) {
          result[key] = ObjectCreator.deepCopy(baseSettings[key]);
        } else {
          result[key] = ObjectCreator.merge(result[key], baseSettings[key]);
        }
      }
      return result;
    }
    return ObjectCreator.deepCopy(detailedSettings);
  }

  static createCopyFunc(copyFunc) {
    return copyFunc === undefined ? ObjectCreator.deepCopy : copyFunc;
  }

  static createMergeFunc(mergeFunc) {
    return mergeFunc === undefined ? ObjectCreator.merge : mergeFunc;
  }
}
